/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PortalAccountStatusResponse,
  PortalEmailAvailabilityResponse,
  ProblemDetails,
  SendPortalInvitationRequest,
} from '../models/index';
import {
    PortalAccountStatusResponseFromJSON,
    PortalAccountStatusResponseToJSON,
    PortalEmailAvailabilityResponseFromJSON,
    PortalEmailAvailabilityResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SendPortalInvitationRequestFromJSON,
    SendPortalInvitationRequestToJSON,
} from '../models/index';

export interface GetClientPortalAccountStatusRequest {
    clientId: string;
}

export interface GetPortalEmailAvailabilityRequest {
    clientId: string;
    email?: string;
}

export interface LockPortalAccountRequest {
    clientId: string;
}

export interface RemovePortalUserRequest {
    clientId: string;
}

export interface ResendPortalInvitationRequest {
    clientId: string;
}

export interface SendPortalInvitationOperationRequest {
    clientId: string;
    sendPortalInvitationRequest: SendPortalInvitationRequest;
}

export interface SendPortalPasswordResetRequest {
    clientId: string;
}

export interface UnlockPortalAccountRequest {
    clientId: string;
}

export interface WithdrawPortalInvitationRequest {
    clientId: string;
}

/**
 * ClientPortalAccountsApi - interface
 * 
 * @export
 * @interface ClientPortalAccountsApiInterface
 */
export interface ClientPortalAccountsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    getClientPortalAccountStatusRaw(requestParameters: GetClientPortalAccountStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalAccountStatusResponse>>;

    /**
     */
    getClientPortalAccountStatus(requestParameters: GetClientPortalAccountStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalAccountStatusResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    getPortalEmailAvailabilityRaw(requestParameters: GetPortalEmailAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalEmailAvailabilityResponse>>;

    /**
     */
    getPortalEmailAvailability(requestParameters: GetPortalEmailAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalEmailAvailabilityResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    lockPortalAccountRaw(requestParameters: LockPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    lockPortalAccount(requestParameters: LockPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    removePortalUserRaw(requestParameters: RemovePortalUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    removePortalUser(requestParameters: RemovePortalUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    resendPortalInvitationRaw(requestParameters: ResendPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    resendPortalInvitation(requestParameters: ResendPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {SendPortalInvitationRequest} sendPortalInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    sendPortalInvitationRaw(requestParameters: SendPortalInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    sendPortalInvitation(requestParameters: SendPortalInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    sendPortalPasswordResetRaw(requestParameters: SendPortalPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    sendPortalPasswordReset(requestParameters: SendPortalPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    unlockPortalAccountRaw(requestParameters: UnlockPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    unlockPortalAccount(requestParameters: UnlockPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortalAccountsApiInterface
     */
    withdrawPortalInvitationRaw(requestParameters: WithdrawPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    withdrawPortalInvitation(requestParameters: WithdrawPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ClientPortalAccountsApi extends runtime.BaseAPI implements ClientPortalAccountsApiInterface {

    /**
     */
    async getClientPortalAccountStatusRaw(requestParameters: GetClientPortalAccountStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalAccountStatusResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientPortalAccountStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/portal-account`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalAccountStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientPortalAccountStatus(requestParameters: GetClientPortalAccountStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalAccountStatusResponse> {
        const response = await this.getClientPortalAccountStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPortalEmailAvailabilityRaw(requestParameters: GetPortalEmailAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalEmailAvailabilityResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getPortalEmailAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/portal-account/email-availability`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalEmailAvailabilityResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPortalEmailAvailability(requestParameters: GetPortalEmailAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalEmailAvailabilityResponse> {
        const response = await this.getPortalEmailAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async lockPortalAccountRaw(requestParameters: LockPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling lockPortalAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/portal-account/lock`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async lockPortalAccount(requestParameters: LockPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.lockPortalAccountRaw(requestParameters, initOverrides);
    }

    /**
     */
    async removePortalUserRaw(requestParameters: RemovePortalUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling removePortalUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/portal-account/user`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removePortalUser(requestParameters: RemovePortalUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePortalUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async resendPortalInvitationRaw(requestParameters: ResendPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling resendPortalInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/portal-account/invitation/resend`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resendPortalInvitation(requestParameters: ResendPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resendPortalInvitationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async sendPortalInvitationRaw(requestParameters: SendPortalInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling sendPortalInvitation().'
            );
        }

        if (requestParameters['sendPortalInvitationRequest'] == null) {
            throw new runtime.RequiredError(
                'sendPortalInvitationRequest',
                'Required parameter "sendPortalInvitationRequest" was null or undefined when calling sendPortalInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/portal-account/invitation`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendPortalInvitationRequestToJSON(requestParameters['sendPortalInvitationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendPortalInvitation(requestParameters: SendPortalInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendPortalInvitationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async sendPortalPasswordResetRaw(requestParameters: SendPortalPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling sendPortalPasswordReset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/portal-account/password-reset`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendPortalPasswordReset(requestParameters: SendPortalPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendPortalPasswordResetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async unlockPortalAccountRaw(requestParameters: UnlockPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling unlockPortalAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/portal-account/unlock`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async unlockPortalAccount(requestParameters: UnlockPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlockPortalAccountRaw(requestParameters, initOverrides);
    }

    /**
     */
    async withdrawPortalInvitationRaw(requestParameters: WithdrawPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling withdrawPortalInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/portal-account/invitation`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async withdrawPortalInvitation(requestParameters: WithdrawPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.withdrawPortalInvitationRaw(requestParameters, initOverrides);
    }

}
